import SectionPerks from './SectionPerks';
export default SectionPerks;
